import { Card, Image } from "antd";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import VisibilitySensor from "react-visibility-sensor";
import card1 from "./images/card-1.png";
import card2 from "./images/card-2.png";
import card3 from "./images/card-3.png";
import card4 from "./images/card-4.png";
import card5 from "./images/card-5.png";
import card6 from "./images/card-6.png";
import styles from "./style.module.scss";

const DashboardArea = () => {
  const { t } = useTranslation();

  const statisticEnum = [
    { value: 6.3, precision: 1, name: "about.dashboard.statistic.name1" },
    { value: 180, precision: 0, name: "about.dashboard.statistic.name2" },
    { value: 20, precision: 0, name: "about.dashboard.statistic.name3" },
    { value: 500000, precision: 0, name: "about.dashboard.statistic.name4" },
  ];

  const renderStatistic = statisticEnum.map((item, index) => {
    return (
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => {
          return (
            <div key={index} className={styles.statistic}>
              {isVisible ? (
                <>
                  <div className={styles.value}>
                    <CountUp start={0} end={item.value} decimals={item.precision} separator="," />
                  </div>
                  <div className={styles.name}>{t(item.name)}</div>
                </>
              ) : null}
            </div>
          );
        }}
      </VisibilitySensor>
    );
  });

  const cardsEnum = [
    {
      src: card1,
      title: "about.dashboard.card.title1",
      content: "about.dashboard.card.content1",
    },
    {
      src: card2,
      title: "about.dashboard.card.title2",
      content: "about.dashboard.card.content2",
    },
    {
      src: card3,
      title: "about.dashboard.card.title3",
      content: "about.dashboard.card.content3",
    },
    {
      src: card4,
      title: "about.dashboard.card.title4",
      content: "about.dashboard.card.content4",
    },
    {
      src: card5,
      title: "about.dashboard.card.title5",
      content: "about.dashboard.card.content5",
    },
    {
      src: card6,
      title: "about.dashboard.card.title6",
      content: "about.dashboard.card.content6",
    },
  ];

  const renderCards = cardsEnum.map((item, index) => {
    return (
      <Card
        key={index}
        cover={
          <div className={styles.imgContainer}>
            <Image src={item?.src} alt="img" preview={false} className={styles.img} />
          </div>
        }
        className={styles.card}
      >
        <div className={styles.title}>{t(item.title)}</div>
        <div className={styles.content}> {t(item.content)} </div>
      </Card>
    );
  });

  return (
    <div className={`${styles.dashboardArea} dashboard-area`}>
      <div className={styles.title}>{t("about.dashboard.title")}</div>
      <div className={styles.statisticContainer}>{renderStatistic}</div>
      <div className={styles.cardsContainer}>{renderCards}</div>
    </div>
  );
};

export default DashboardArea;
